import { render, staticRenderFns } from "./MaintenanceForm.vue?vue&type=template&id=b0e70f56&scoped=true&"
import script from "./MaintenanceForm.vue?vue&type=script&lang=js&"
export * from "./MaintenanceForm.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceForm.vue?vue&type=style&index=0&id=b0e70f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e70f56",
  null
  
)

export default component.exports